import { render } from "./CarCareTop.vue?vue&type=template&id=1145b3ca"
import script from "./CarCareTop.vue?vue&type=script&lang=js"
export * from "./CarCareTop.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/CarCareTop.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1145b3ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1145b3ca', __exports__)) {
    api.reload('1145b3ca', __exports__)
  }
  
  module.hot.accept("./CarCareTop.vue?vue&type=template&id=1145b3ca", () => {
    api.rerender('1145b3ca', render)
  })

}


export default __exports__